/**
 * Created by Ning Jiang on 2021-06-28.
 */

import {ContinueScreen} from "../../core/screen/ContinueScreen";
import {OpenSans} from "@nolimitcity/slot-launcher/bin/loader/font/OpenSans";
import {FontWeight} from "@nolimitcity/slot-launcher/bin/loader/font/FontStatics";
import {KarenLayers, Layers} from "../view/KarenLayers";
import {Karen} from "../Karen";
import {TimelineLite} from "gsap";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {GameMode} from "@nolimitcity/slot-game/bin/flowcontrol/GameMode";
import {KarenParsedGameData} from "../server/data/KarenParsedGameData";
import {KarenParsedInitData} from "../server/data/KarenParsedInitData";
import {SpinePlayer} from "../../core/displayObject/SpinePlayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {KarenReelController} from "../reels/KarenReelController";
import {KarenSoundManager} from "../sound/KarenSoundManager";
import {KarenSoundConfig} from "../sound/KarenSoundConfig";
import {KarenGameConfig} from "../KarenGameConfig";
import {GameHelper} from "../../core/utils/GameHelper";

export class FreespinIntro extends ContinueScreen {

    private _text: PIXI.Text;
    private _introSpine: SpinePlayer;

    constructor() {
        super(KarenLayers.getLayer(Layers.SCREENS)!);
        this._text = new PIXI.Text("", new PIXI.TextStyle({
            fill: "1f1811",
            fontFamily: "Impact",
            wordWrap: false,
            fontWeight: FontWeight.BOLD,
            fontSize: 55
        }));
        this._text.anchor.set(0.5, 0.5);
        this._text.position.set(576, 121);
        this._container.addChild(this._text);
        this._text.visible = false;
        this._introSpine = new SpinePlayer("fs_intro_outro", false);
    }

    public show(onContinueCallBack: () => void): void {
        const tl: TimelineLite = new TimelineLite();
        this._introSpine.alpha = 0;
        if (Karen.model.isRestore) {
            KarenSoundManager.stopSoundEffect(KarenSoundConfig.MAIN_GAME_MUSIC);
            tl.add(this.fadeInContents());
        } else {
            this._introSpine.alpha = 1;
        }
        KarenGameConfig.IS_FEATURE_BUY = false;
        SlotGame.keypadPlugin.hide();
        Karen.reels.forEach((reel: KarenReelController) => {
            reel.changeReelSet("FREESPIN_REELSET")
        });
        let level: number = GameHelper.getFSLevel(Karen.model.parsedInitData!);
        if (Karen.model.parsedGameData) {
            if (Karen.model.parsedGameData) {
                level = GameHelper.getFSLevel(Karen.model.parsedGameData!);
            }
        }
        let skinType = GameHelper.getSkinType(level);
        this._introSpine.position.set(360, 360);
        tl.add(this._introSpine.play({
            name: "intro_start", loop: false, skinType: skinType, showOnEnd: true, onStart: () => {
                //   KarenSoundManager.playSoundEffect(KarenSoundConfig.FREESPIN_INTRO_LOOP);
                KarenSoundManager.switchMusic({name: KarenSoundConfig.FREESPIN_INTRO_LOOP}, {
                        name: KarenSoundConfig.FREESPIN_INTRO_LOOP,
                        to: 1,
                        duration: 100
                    },
                    {name: KarenSoundConfig.MAIN_GAME_MUSIC, to: 0, duration: 100});
            }
        }).add(() =>{
            this._introSpine.play({
                name: "intro_loop",
                skinType: skinType,
                loop: true,
                showOnEnd: true
            })}));
        tl.add(() => {
            this._text.visible = true;
        }, this._introSpine.fetchDuration("intro_start") / 3);
        this._container.addChild(this._introSpine);
        this._container.addChild(this._text);
        const fsLeft: number = Karen.model.isRestore ? Karen.model.parsedInitData.freespinsLeft : Karen.model.parsedGameData.freespinsLeft;
        let xWaySize: number = Karen.model.isRestore ? Karen.model.parsedInitData.fsXWaysSize : Karen.model.parsedGameData.fsXWaysSize;
        const symbolSizes: number[][] = Karen.model.isRestore ? Karen.model.parsedInitData.symbolSizes : Karen.model.parsedGameData.symbolSizes;
        let parsedData: KarenParsedGameData | KarenParsedInitData;
        if (Karen.model.isRestore) {
            parsedData = Karen.model.parsedInitData;
        } else {
            parsedData = Karen.model.parsedGameData;
        }
        const mode: string = parsedData.mode;
        const doReelNudge: boolean = parsedData.doReelNudge;
        if (mode === GameMode.NORMAL && Karen.model.isRestore) {
            this.revealXWMultiplier(symbolSizes, parsedData);
        }
        let wildIndexInReel: number = parsedData.initReels[5].indexOf("W");
        let finalWildIndex: number = parsedData.reelsEnteringFreespin[5].indexOf("W");
        let nudgeMultiplier: number = symbolSizes[5][0];
        if (mode === GameMode.NORMAL && finalWildIndex > 0 && finalWildIndex < parsedData.reelsEnteringFreespin[5].length - 1) {
            nudgeMultiplier = (finalWildIndex - wildIndexInReel) + 1;
        }
        if ((mode === GameMode.NORMAL && nudgeMultiplier > 0 && doReelNudge)) { //&& (Karen.model.isRestore)
            if (nudgeMultiplier > 0) {
                this.revealMultiplierOnXNudgeWild(symbolSizes[5], parsedData)
            }
            xWaySize = nudgeMultiplier + 2;
        }
        if (Karen.model.parsedInitData && Karen.model.isRestore) {
            const isFSTrigger: boolean = (Karen.model.parsedInitData.mode === GameMode.NORMAL && Karen.model.parsedInitData.nextMode === GameMode.FREESPIN);
            if (isFSTrigger) {
                for (let reelIndex: number = 0; reelIndex < 6; reelIndex++) {
                    if (Karen.model.parsedInitData.stickyXWaysFSPositions![reelIndex] > -1) {
                        Karen.stickyXWView.showStickyXW(reelIndex, Karen.model.parsedInitData.fsXWaysSize);
                    }
                }
            }
        }
        this._text.text = `${fsLeft}`;
        Karen.background.setXWaysFSSize(xWaySize.toString());
        Karen.reel2Frame.updateMode(GameMode.FREESPIN);
        Karen.xwaysMultiplierView.setFSXWays();
        Karen.background.updateBackGround(GameMode.FREESPIN);
        super.show(onContinueCallBack);
    }

    public revealMultiplierOnXNudgeWild(symbolSizes: number[], parsedData: KarenParsedGameData | KarenParsedInitData): void {
        symbolSizes.forEach((value: number, symIndex: number) => {
            if (parsedData.xWInfPositions[5].indexOf(symIndex) > -1) {
                Karen.reels[5].getSymbol(symIndex).revealMultiplier(value, false, true, true);
            } else {
                Karen.reels[5].getSymbol(symIndex).showXMultiplier(value);
            }
        });
    }

    public revealXWMultiplier(symbolSizes: number[][], parsedData: KarenParsedGameData | KarenParsedInitData): void {
        symbolSizes.forEach((eachReel: number[], reelId: number) => {
            if (reelId < 5) {
                eachReel.forEach((value: number, symIndex: number) => {
                    if (parsedData.xWInfPositions[reelId].indexOf(symIndex) > -1) {
                        value > 1 && Karen.reels[reelId].getSymbol(symIndex).showXMultiplier(value, true);
                    } else {
                        value > 1 && Karen.reels[reelId].getSymbol(symIndex).showXMultiplier(value, false);
                    }
                });
            }
        });
    }

    protected close(): TimelineLite {
        if (this._introSpine) {
            this._introSpine.stop(false);
            this._text.visible = false;
        }
        KarenSoundManager.playSoundEffect(KarenSoundConfig.FREESPIN_START);
        KarenSoundManager.switchMusic({name: KarenSoundConfig.FREESPIN_GAME_MUSIC}, {
            name: KarenSoundConfig.FREESPIN_GAME_MUSIC,
            to: 1,
            duration: 100
        }, {name: KarenSoundConfig.FREESPIN_INTRO_LOOP, to: 0, duration: 100});
        KarenSoundManager.playTrack(KarenSoundConfig.FREESPIN_WIN_LOOP, 0);
        SlotGame.keypadPlugin.show();
        return super.close();
    }

    private fadeInContents(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.to(this._introSpine, 0.3, {alpha: 1, ease: 'power1.in'});
        return tl;
    }
}
